var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"liveticker-title"},[_c('h1',{staticClass:"title"},[_vm._v("Liveticker")]),_c('transition',[(_vm.sponsor)?_c('sponsored-by',{attrs:{"sponsor":_vm.sponsor,"sponsor-link":_vm.sponsorLink}}):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }